module.exports = __webpack_public_path__ + "img/dead-tree-desert-00.2aeb5b18.png";